import React from "react"
import "../styles/app.scss"
import { GridLayout, Demo } from "@wp/ui"
import SEO from "./seo"
import { LinksProp, GraphQLData, BlogPostFrontmatter } from "../utils/types"
import Logo from "../img/logo.inline.svg"
import MarkLogo from "../img/mark.inline.svg"
import magazineImg from "../img/Writers-Print (4).png"
import minimalImg from "../img/Writers-Print (3).png"
import lifestyleImg from "../img/Writers-Print (5).png"
import photographyImg from "../img/Writers-Print (2).png"
import useSiteMetadata from "./SiteMetadata"
import { useStaticQuery, graphql } from "gatsby"

type LayoutComponent = {
  title?: string
  withFooter?: boolean
}

const Layout: React.FC<LayoutComponent> = ({
  children,
  withFooter = true,
  title = "",
}) => {
  const siteMetadata = useSiteMetadata()

  const data: GraphQLData<BlogPostFrontmatter> = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
      ) {
        edges {
          node {
            excerpt(pruneLength: 400)
            id
            fields {
              slug
            }
            frontmatter {
              title
              templateKey
              date(formatString: "MMMM DD, YYYY")
              featuredpost
              description
              image {
                childImageSharp {
                  fluid(maxWidth: 780, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const { edges } = data.allMarkdownRemark

  const pageLinks: LinksProp[] = [
    { name: "Home", to: "/" },
    { name: "About", to: "/about" },
    { name: "Contact", to: "/contact" },
    { name: "404", to: "/404" },
  ]

  return (
    <>
      <SEO title={title} />
      <GridLayout
        pageLinks={pageLinks}
        siteMetadata={siteMetadata}
        logo={Logo}
        posts={edges}
        withFooter={withFooter}
        footerLogo={MarkLogo}
      >
        {children}
      </GridLayout>
      <Demo
        demos={[
          { img: minimalImg, url: "djf", title: "Minimal" },
          { img: photographyImg, url: "djf", title: "Photography" },
          { img: lifestyleImg, url: "djf", title: "Lifestyle" },
          { img: magazineImg, url: "djf", title: "Magazine" },
        ]}
      />
    </>
  )
}

export default Layout
